export default __webpack_public_path__ + "static/gotham-bold-69208b1012670bc49c20498d18f6dc35.woff2";